export default [
    {
        path: "/login", // Change kora holo
        name: "login",
        component: () => import("@/views/auth/LoginView.vue"),
        meta: {
          pageTitle: "Login",
          requiresAuth: false,
          redirectIfLoggedIn: true, // Login thakle jate dashboard e niye jay
          layout: "full",
        },
    }
]